import { useState } from 'react';

const faqItems = [
  {
    question: '华体会官网是正规平台吗？',
    answer: '华体会官网是持有正规运营牌照的体育娱乐平台，采用国际领先的安全加密技术，严格遵守行业规范，为广大用户提供安全可靠的体育竞猜服务。',
  },
  {
    question: '如何在华体会官网注册账号？',
    answer: '访问华体会官网首页，点击"立即注册"按钮，填写手机号或邮箱地址，设置登录密码，完成手机验证即可成功注册。注册后即可享受新人专属福利。',
  },
  {
    question: '华体会官网支持哪些充值方式？',
    answer: '华体会官网支持多种充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等多种渠道，充值实时到账，方便快捷。',
  },
  {
    question: '华体会官网提现需要多长时间？',
    answer: '华体会官网提现处理效率极高，一般情况下小额提现5分钟内到账，大额提现24小时内处理完成。我们致力于为用户提供最快的资金流转体验。',
  },
  {
    question: '华体会官网有哪些体育竞猜项目？',
    answer: '华体会官网覆盖足球、篮球、网球、电竞、乒乓球、羽毛球、F1赛车、高尔夫等数十种体育项目，提供胜负、让分、大小分、比分等多种竞猜玩法。',
  },
  {
    question: '华体会官网会员福利有哪些？',
    answer: '华体会官网为新会员提供注册礼金和首充优惠；为老会员提供每日签到奖励、周周返水、节日专属活动、VIP等级特权等多重福利，让每一次投注都物超所值。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            华体会官网为您解答最关心的问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`text-foreground-500 text-lg transition-transform duration-300 shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}